import { Wheelchair_Blue } from '../Icons/CustomIcons';
import FieldInfo from '../Common/FieldInfo';
import { Checkbox } from './Checkbox';

export const WheelchairCheckbox = ({
  checked,
  onCheckedChange,
  icon: Icon = Wheelchair_Blue,
  iconSize = 20,
  showFieldInfo = false,
  fieldInfoText = '',
}) => (
  <div className="wheelchair-filter">
    <Checkbox
      id="wheelchair-accessible"
      checked={checked}
      onCheckedChange={onCheckedChange}
      label={
        <span className="body Font-M-S-130-T Colors-Black wheelchair-checkbox__label">
          <span className="icon-wrap-wheelchair">
            <Icon size={iconSize} />
          </span>
          Nur rollstuhlgerechte Aktivitäten
          {showFieldInfo && <FieldInfo text={fieldInfoText} />}
        </span>
      }
    />
  </div>
);